import { gsap } from 'gsap';
import { debounce } from 'lodash';
import { Util } from './_util.js';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Cookies from 'js-cookie';

gsap.registerPlugin(ScrollTrigger);

const clubProfile = {
  gridder: function() {
    jQuery('.gridder').gridderExpander({
      scroll: true,
      scrollOffset: 30,
      scrollTo: 'panel', // panel or listitem
      animationSpeed: 400,
      animationEasing: 'easeInOutExpo',
      showNav: true, // Show Navigation
      nextText: 'Next', // Next button text
      prevText: 'Previous', // Previous button text
      closeText: '', // Close button text
      onStart: function() {
        //Gridder Inititialized
      },
      onContent: function() {
        //Gridder Content Loaded
      },
      onClosed: function() {
        //Gridder Closed
      },
    });
  },

  urlClubDetect: function() {
    let previousUrl = '';
    let timer;
    let addLinkFlag = false;

    const observer = new MutationObserver(function(mutations) {
      let urlCapture = new URL(window.location);

      if (urlCapture.pathname !== previousUrl) {
        previousUrl = urlCapture.pathname;
        // return urlCapture.pathname;
      }

      //remove reservation & myForest link
      let dashboardMenuLinks = document.querySelectorAll('.c7-account__menu li a');
      [...dashboardMenuLinks].forEach((el) => {
        if (el.href.includes('ecologi') || el.href.includes('reservation') || el.href.includes('allocation')) {
          el.parentElement.remove();
        }
      });

      function checkClub() {
        //   console.log('checkclub');

        if (urlCapture.pathname.includes('profile') && !addLinkFlag) {
          if (!document.body.contains(document.querySelector('.c7-account__menu'))) return;
          if (document.body.contains(document.querySelector('.portal-link'))) {
            observer.disconnect();
          }

          let accountMenu = document.querySelector('.c7-account__menu');

          // if (!document.body.contains(document.querySelector('.portal-link'))) {
          //   if (!clubProfile.isClubMember) return;
          //   let portalLink = `<li><a class="portal-link" href="/club-member-exclusive-portal">Club Exclusive Portal</a></li>`;
          //   $('.c7-account__menu .c7-wrapper li:nth-of-type(4)').after(portalLink);
          // }

          if (!document.body.contains(document.querySelector('.club-account-banner'))) {
            let getC7ParentEl = document.querySelector('#c7-content').parentElement;

            getC7ParentEl.insertAdjacentHTML(
              'beforebegin',
              `<div class="account-banner-ctr"><p class="club-account-banner"><a href="/club-member-exclusive-portal">Insider Information</a></p>
            <p class="club-account-banner"><a href="/profile/club-membership">See Your Club Memberships</a></p></div>`
            );
          }

          // accountMenu.insertAdjacentHTML('beforeEnd', portalLink);

          addLinkFlag = !addLinkFlag;

          setTimeout(() => {
            addLinkFlag = false;

            setTimeout(() => {
              observer.disconnect();
            }, 10000);
          }, 4000);
        }
      }

      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        checkClub();
      }, 500);
    });

    const config = { subtree: true, childList: true };
    observer.observe(document, config);
  },
  urlAllocationDetect: function() {
    let previousUrl = '';
    let timer;
    let addLinkFlag = false;

    const observer = new MutationObserver(function(mutations) {
      let urlCapture = new URL(window.location);

      if (urlCapture.pathname !== previousUrl) {
        previousUrl = urlCapture.pathname;
        // return urlCapture.pathname;
      }

      function check() {
        if (urlCapture.pathname.includes('allocation') && !addLinkFlag) {
          if (document.body.contains(document.querySelector('.c7-account-allocations'))) {
            let alloProductList = document.querySelectorAll('.c7-product-allocation__product-list');

            let parentEl = document.querySelector('.c7-account-allocations .c7-wrapper');

            [...alloProductList].forEach((e) => {
              if (e.children.length > 1) {
                [...e.children].forEach((el) => {
                  let foundElement;
                  foundElement = el;
                  let clone = foundElement.cloneNode(true);
                  el.remove();

                  parentEl.appendChild(clone);
                });

                // foundElement = e;

                // let clone = foundElement.cloneNode(true);
                // e.remove();

                // parentEl.appendChild(clone);

                // let newEl = `
                // <div class="c7-product-allocation">
                //   <div class="c7-product-allocation__product-list">
                //     ${foundElement}
                //   </div>
                // </div>
                // `;
                // parentEl.appendChild(newEl);
              }
            });
          }

          // accountMenu.insertAdjacentHTML('beforeEnd', portalLink);

          addLinkFlag = !addLinkFlag;

          setTimeout(() => {
            addLinkFlag = false;
          }, 4000);
        }
      }

      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        check();
      }, 500);
    });

    const config = { subtree: true, childList: true };
    observer.observe(document, config);

    setTimeout(() => {
      observer.disconnect();
    }, 5000);
  },
  urlClubModalDetect: function() {
    let previousUrl = '';
    let timer;
    let addLinkFlag = false;

    const observer = new MutationObserver(function(mutations) {
      let urlCapture = new URL(window.location);

      if (urlCapture.pathname !== previousUrl) {
        previousUrl = urlCapture.pathname;
        // return urlCapture.pathname;
      }

      function check() {
        if (urlCapture.pathname.includes('profile') || urlCapture.pathname.includes('club')) {
          if (document.body.contains(document.querySelector('.c7-modal-container.c7-account-club-shipment'))) {
            document.querySelector('.rmbr.header').classList.add('club-modal-active');
          } else {
            document.querySelector('.rmbr.header').classList.remove('club-modal-active');
          }

          // accountMenu.insertAdjacentHTML('beforeEnd', portalLink);

          addLinkFlag = !addLinkFlag;

          setTimeout(() => {
            addLinkFlag = false;
          }, 4000);
        } else {
          document.querySelector('.rmbr.header').classList.remove('club-modal-active');
        }
      }

      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        check();
      }, 500);
    });

    const config = { subtree: true, childList: true };
    observer.observe(document, config);

    setTimeout(() => {
      observer.disconnect();
    }, 5000);
  },
  equalHeight: function() {
    let max;
    let heightArray = [];
    let list = document.querySelectorAll('.gridder-list');

    [...list].forEach((el) => {
      heightArray.push(el.offsetHeight);
    });

    console.log('heightArray', heightArray);

    max = heightArray.reduce(function(a, b) {
      return Math.max(a, b);
    }, -Infinity);

    console.log(max);

    ScrollTrigger.matchMedia({
      // large
      '(min-width: 997px)': function() {
        [...list].forEach((el) => {
          el.style.height = max + 'px';
        });
      },

      // medium
      '(min-width: 600px) and (max-width: 959px)': function() {
        // The ScrollTriggers created inside these functions are segregated and get
        // reverted/killed when the media query doesn't match anymore.
      },

      // small
      '(max-width: 599px)': function() {
        // The ScrollTriggers created inside these functions are segregated and get
        // reverted/killed when the media query doesn't match anymore.
      },

      // all
      all: function() {
        // ScrollTriggers created here aren't associated with a particular media query,
        // so they persist.
      },
    });
  },
  isClubMember: false,
  getClubStatusv2: function() {
    let C7tenant = window.stagingC7 ? 'staging-rombauer' : 'rombauer-vineyards';

    let customerToken = Cookies.get('customerToken');

    if (typeof customerToken == 'undefined') return;
    //console.log('customerToken', Cookies.get('customerToken'));

    if (clubProfile.isClubMember) return;

    fetch(`https://api.commerce7.com/v1/customer/self`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        tenant: C7tenant,
        authorization: customerToken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.clubs.length > 0) {
          clubProfile.isClubMember = true;
          localStorage.setItem('RMBClubMember', 1);
        } else {
          localStorage.setItem('RMBClubMember', 0);
        }
      });
  },
  blur: function() {
    let timer;
    let blurFire = true;

    if (clubProfile.isClubMember || localStorage.getItem('RMBClubMember') == 1) {
      // console.log('is a club member 2');

      return;
    } else {
      blurFire = false;
      document.querySelector('.rmbr.grid__content').classList.add('blur');
      // alert('Please become a club member to view.');

      jQuery('.rmbr.popup').addClass('popup--opn');
      jQuery('body').css({ overflow: 'hidden' });

      setTimeout(() => {
        window.location.href = location.origin + '/profile/account';
      }, 3000);

      blurFire = !blurFire;
    }

    // if (clubProfile.getClubStatus == true) {
    //   console.log('is a club member 2');
    //   return;
    // } else {
    //   blurFire = false;
    //   alert('If you are a club member, please log in to view.');
    //   window.location.href = location.origin + '/profile/login';
    //   blurFire = !blurFire;
    // }
  },
  enableSelectSkipClub: function() {
    if (!document.body.contains(document.querySelector('.c7-account-club-shipments'))) return false;

    let clubs = document.querySelectorAll('.c7-account-club-shipments .c7-account-club');

    [...clubs].forEach((el) => {
      let clubTitle = el.querySelector('.c7-h2').innerText.toLowerCase();
      let clubCancelListener = el.querySelector('.c7-account-blocks--status button');

      if (clubTitle.includes('chardonnay club') || clubTitle.includes('classic club')) {
        let skipButton = el.querySelector('.c7-account-club__shipment__footer .c7-btn--skip');

        if (skipButton && !skipButton.classList.contains('show')) {
          skipButton.classList.add('show');

          if (clubCancelListener.innerText.toLowerCase().includes('cancel')) {
            clubCancelListener.addEventListener('click', () => {
              setTimeout(() => {
                let modalContent = document.querySelector('.c7-form');
                let firstParagraph = modalContent.querySelector('p');
                let newParagraph = document.createElement('p');

                newParagraph.innerText = "Would you like to opt to skip this shipment instead of canceling your membership? If so, please close this pop-up and click 'Skip Shipment'.";
                modalContent.insertBefore(newParagraph, firstParagraph);
              }, 750);
            });
          }
        }
      }
    });

    clubProfile.swapClubButtons();
  },
  swapClubButtons: function() {
    let intervalId = setInterval(function() {
      let url = new URL(window.location);

      if (
        url.pathname.includes('/profile/club-membership') &&
        document.body.contains(document.querySelector('.c7-account-club-shipments')) &&
        document.body.contains(document.querySelector('.c7-order-items--shipment')) &&
        document.body.contains(document.querySelector('.c7-account__header'))
      ) {
        document.querySelectorAll('.c7-account-club').forEach((clubElement) => {
          const headerActions = clubElement.querySelector('.c7-account-club__header__actions');
          const footer = clubElement.querySelector('.c7-account-club__shipment__footer');
          const shipItNowButton = clubElement.querySelector('.c7-account-club__header__actions .c7-btn--alt');
          const editWinesAnchor = clubElement.querySelector('.c7-account-club__header__actions .c7-btn--edit');
          const skipShipmentButton = clubElement.querySelector('.c7-account-club__shipment__footer .c7-btn--skip');
          const cancelShipmentButton = clubElement.querySelector('.c7-account-blocks--status .c7-account-block__actions');

          if (headerActions && footer && shipItNowButton && editWinesAnchor && skipShipmentButton && cancelShipmentButton) {
            footer.prepend(shipItNowButton);
            footer.prepend(editWinesAnchor);
            cancelShipmentButton.appendChild(skipShipmentButton);
          }
        });
      }
    }, 500);
  },
  activeClubCheck: function() {
    // Check if the URL contains "#active"
    if (window.location.hash !== '#active') {
      return; // Exit the function if "#active" is not in the URL
    }

    // Check if the function has already scrolled to the element
    if (clubProfile.hasScrolledToElement) {
      return; // Exit the function if it has already scrolled to the element
    }

    // Get all .c7-account-club elements
    let clubs = document.querySelectorAll('.c7-account-club');

    // Iterate over each .c7-account-club element
    for (let i = 0; i < clubs.length; i++) {
      let club = clubs[i];

      // Check if .c7-btn--edit exists inside of the .c7-account-club__shipment__footer element
      let editButton = club.querySelector('.c7-account-club__shipment__footer .c7-btn--edit');

      // If the edit button is found, scroll to the .c7-account-club__header__title inside of the .c7-account-club element
      if (editButton) {
        let title = club.querySelector('.c7-account-club__header__title');
        if (title) {
          title.scrollIntoView({ behavior: 'smooth' });
          clubProfile.hasScrolledToElement = true; // Set the flag to true after scrolling
          break; // Stop the loop after finding the first match
        }
      }
    }
  },
  hasScrolledToElement: false, // Initialize the flag as false
  init: function() {
    window.addEventListener('load', (event) => {
      setTimeout(() => {
        clubProfile.getClubStatusv2();
        clubProfile.urlClubDetect();
        clubProfile.urlClubModalDetect();
        //    clubProfile.urlAllocationDetect();
      }, 500);
    });

    //on initial load of profile page check if club member
    let url = new URL(window.location);

    if (url.pathname.includes('profile') || url.pathname.includes('club')) {
      let intervalId = setInterval(function() {
        clubProfile.getClubStatusv2();
        clubProfile.urlClubDetect();
        clubProfile.urlClubModalDetect();
        clubProfile.enableSelectSkipClub();

        clubProfile.activeClubCheck();
        //    clubProfile.urlAllocationDetect();
        //  clubProfile.swapClubButtons();
      }, 1000); // Check every 500 milliseconds
    }

    if (!document.body.contains(document.querySelector('#club-news-section'))) return;
    this.gridder();

    window.addEventListener('load', (event) => {
      setTimeout(() => {
        clubProfile.equalHeight();
        clubProfile.blur();
      }, 400);
    });
  },
};

export default clubProfile;
